import { ReactNode, useEffect } from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import {
  selectVideoPageNumber,
  selectCompanyVideo,
  selectCompanyVideoLoading,
  selectCompanyVideoEnded,
  selectVideoFlurry,
  selectVideoCall,
} from 'Selector/CompaniesSelector';
import { useDispatch, useSelector } from 'react-redux';
import { Article } from 'Types/ArticleTypes';
import NoPersonsFound from 'Components/common/components/NoPersonsFound';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSearchParams } from 'react-router-dom';
import { valueToObject } from 'Utils/UtilityFunctions';
import { actions as helperActions } from 'Slice/HelperSlice';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import { NODATABASEDONFILTERS } from 'Utils/Constants';
import { boxShadow, white } from 'Utils/utilsStyle';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import VideoGridLayout from 'Components/common/components/VideoGridLayout';
import { actions as companiesActions } from '../../../Slice/CompaniesSlice';

const Wrapper = styled.div`
  padding: 24px 12px;
  background: ${white};
  box-shadow: ${boxShadow};
  border-radius: 16px;

  & .heading-inner-page{
    padding: 0 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    .right-side-sub-header {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      margin-left: auto;

      .view-tabs {
        pointer-events: auto;
      }
    }
  }

  & .companyVideosArticlesWrapper{

    .infiniteScrollWrapper{
      padding: 0 12px;
      padding-top: 20px;
    }
  }
`;
type Props = {
  listview: boolean;
  headerActions?: ReactNode;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
};

const CompanyVideoTab = function CompanyVideoTab(props: Props) {
  const companyVideoArticles: Article[] | null = useSelector(selectCompanyVideo);
  const isCompanyVideoLoading: boolean = useSelector(selectCompanyVideoLoading);
  const companyVideoEnded: boolean = useSelector(selectCompanyVideoEnded);
  const videoPageNumber: number = useSelector(selectVideoPageNumber);
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const flurryObject = useSelector(selectVideoFlurry);
  const isCalled = useSelector(selectVideoCall);
  const dispatch = useDispatch();
  const { listview, headerActions } = props;

  const fetchMoreVideo = () => {
    if (
      companyVideoArticles
      && companyVideoArticles?.length
      && !isCompanyVideoLoading
    ) {
      dispatch(companiesActions.getCompanyVideos({
        companyId: companyIdParsed,
        page: videoPageNumber,
        videos: true,
      }));
    }
  };

  useEffect(() => {
    if (Object.keys(flurryObject).length) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('company_videos', 0, {
          ...flurryObject,
          isDeleteTime: true,
          ...isCalled && { isCalled },
        }),
      ));
      dispatch(companiesActions.setVideoCall(true));
    }
  }, [flurryObject]);

  return (
    <Wrapper>
      <div className="heading-inner-page">
        <h1 className="heading">
          Videos
        </h1>
        {headerActions ? (
          <div className="right-side-sub-header">
            {headerActions}
          </div>
        ) : null}
      </div>
      {!isCompanyVideoLoading && companyVideoArticles && companyVideoArticles.length < 1
        ? (
          <Row gutter={[16, 16]}>
            <Col span={24} className="article-grid">
              <NoPersonsFound title={NODATABASEDONFILTERS} />
            </Col>
          </Row>
        ) : (
          <div className="companyVideosArticlesWrapper">
            <InfiniteScroll
              dataLength={companyVideoArticles ? companyVideoArticles.length : 0}
              next={fetchMoreVideo}
              hasMore={!companyVideoEnded}
              loader={isCompanyVideoLoading && (
              <div>
                {listview ? (
                  <ArticleListLoadingSkeletonBundle />
                ) : (
                  <ArticleLoadingSkeletonBundle />
                )}
              </div>
              )}
              className="o-x-hidden o-y-hidden infiniteScrollWrapper"
            >
              <VideoGridLayout articlesArray={companyVideoArticles} listview={listview} />
            </InfiniteScroll>
          </div>
        )}
    </Wrapper>
  );
};

export default CompanyVideoTab;
